export const DASHBOARD_LAYOUT_MAX_WIDTH = 1920;
export const DASHBOARD_LAYOUT_CONTENT_MAX_WIDTH = 1536;
export const LANDING_PAGE_CONTENT_MAX_WIDTH = 1200;
export const DASHBOARD_LAYOUT_CHILDREN_MAX_WIDTH = 706;
export const CHAT_WEB_COLUMN_HEIGHT_RATIO = 0.87;
